import React from 'react';
import {
	Pie,
	PieChart,
	type PieSectorShapeProps,
	Sector,
	Tooltip,
	useActiveTooltipDataPoints,
	useIsTooltipActive,
} from 'recharts';
import './FinancementPieChart.css';

const clamp = (value: number): number => Math.min(Math.max(value, 0), 100);

const formatValue = (value: number) => {
	return `${(clamp(value * 100)).toFixed(2)}%`;
};

const customShape = (props: PieSectorShapeProps) => {
	const p = useActiveTooltipDataPoints();
	const isAnyPieActive = useIsTooltipActive();
	const isThisPieActive = isAnyPieActive && props.payload === p?.[0];
	let fillOpacity = 1;

	if (isAnyPieActive && !isThisPieActive) {
		fillOpacity = 0.5;
	}

	return (
		<Sector
			{...props}
			className="financementPieChartSector"
			fill={props.color}
			fillOpacity={fillOpacity}
		/>
	);
};

const FinancementPieChart = ({ autofinancement, externe, montantProjet }) => {
	const data = React.useMemo(
		() => [
			{
				color: '#ED7D31',
				name: 'Auto financement',
				value: (autofinancement ?? 0) / montantProjet,
			},
			{
				color: '#5B9BD5',
				name: 'Financements externes',
				value: (externe ?? 0) / montantProjet,
			},
		],
		[autofinancement, externe, montantProjet],
	);

	return (
		<PieChart className="financementPieChart" responsive>
			<Pie
				data={data}
				dataKey="value"
				isAnimationActive
				label={({ value }) => formatValue(value)}
				shape={customShape}
			/>
			<Tooltip formatter={(value) => formatValue(value)} />
		</PieChart>
	);
};

export default FinancementPieChart;
